import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { DateTime } from 'luxon';

import useLiveData from 'hooks/useLiveData';
import { useLocalStorage } from "@uidotdev/usehooks";

import zparse from 'helpers/zparse';

import close from 'images/close.svg';
import alertIcon from 'images/alert.svg';

const Message = () => {
	let alert;
	const tmp = useStaticQuery(graphql`
		query {
		  allMessage(
			filter: {approved: {eq: true}, deleted: {eq: false}, archived: {eq: false}}
			sort: {fields: showDate, order: DESC}
		  ) {
			edges {
			  node {
				id
				title
				message
				showDate
			  }
			}
		  }
		}
	  `)

	const { statusText: providerStatusText, status: providerStatus, response: providerResponse, visibilityChange } = useLiveData({
		type: 'Message',
		method: 'all',
		apiParams: {
			_include: 'id,title,message,showDate',
			approved: true,
			deleted: false,
			archived: false,
			_sort: 'showDate',
			_order: 'desc',
		},
		staticData: tmp,
	});

	const isLoaded = providerStatusText === 'LOADED';
	const alertId = `alert-${providerResponse.data[0]?.id}`;
	const [dismissed, setDismissed] = useLocalStorage(alertId, false);

	React.useEffect(() => {
		// if dismissed timestamp is older than 1 week reset the value
		if (dismissed && DateTime.now().ts - dismissed > 604800) {
			setDismissed(false)
		}
	}, [dismissed, setDismissed, isLoaded]);

	if (providerStatus < 2) return null; // This prevents any flash of content until the API is loaded -- but if the API takes a while to respond the effect would be the page loads slower. You could also use state to reveal content with a transition
	if ((providerResponse.data.length > 0 || !!alert !== false) && providerStatusText === 'LOADED') {
		alert = providerResponse.data[0];
	}
	if (providerResponse && visibilityChange) alert = providerResponse.data[0];
	if (!!alert === false && providerStatus >= 2) return null;

	const { title, message, showDate } = alert;

	const displayDate = DateTime.fromISO(showDate).toFormat('LLL. d, yyyy');
	return (
		<div className={`alert-wrapper ${dismissed ? '' : 'show-me'}`}>
			<div className={`alert`}>
				<div className='grid-container'>
					<div className='grid-x grid-margin-x align-center'>
						<div className='small-12 medium-8 cell'>
							<div className='flx-wrapper'>
								<div className='icon show-for-medium'>
									<img src={alertIcon} alt={`Alert Icon`} />
								</div>
								<div className='content'>
									<h2>{title}</h2>
									<small>{displayDate}</small>
									<div className='message'>
										{zparse(message)}
									</div>
								</div>
								<button className='close' onClick={() => { setDismissed(DateTime.now().ts) }}>
									<img src={close} alt={`Dismiss Alert`} />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Message;